import { Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanMatch {

    PUBLIC_ROUTES = [
        '/firma-formulario-afiliacion',
        '/contratacion-formulario',
        '/cargue-documentos'
    ];

    /**
     * Constructor
     */
    constructor(
        private readonly _authService: AuthService,
        private readonly _router: Router
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Can match
     *
     * @param route
     * @param segments
     */
    canMatch(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
        return this._check(segments);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Check the authenticated status
     *
     * @param segments
     * @private
     */
    private _check(segments: UrlSegment[]): Observable<boolean | UrlTree>{
        // Check the authentication status
        return this._authService.check().pipe(
            switchMap((authenticated) => {

                const redirectURL = `/${segments.join('/')}`;
                const isPublicRoute = this.PUBLIC_ROUTES.some( route => redirectURL.startsWith(route));
                // If the user is not authenticated...
                if (!authenticated && !isPublicRoute) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const urlTree = this._router.parseUrl(`sign-in?redirectURL=${redirectURL}`);
                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );
    }
}